if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
var intervalID;

(function(){
    
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //load offer by hash
    if(window.location.pathname.length>1){
        startInterval();
    }
    

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.top-content__slider').slick({
        pauseOnHover: false
    });
    $('.top-content__progress').addClass('active');
    $('.top-content__slider').on("beforeChange", function(event, slick, currentSlide, nextSlide){
        $('.top-content__progress').removeClass('active');
        setTimeout(function(){
            $('.top-content__progress').addClass('active');
        },50);
    });

    $('.slider-gallery__slider').slick({
        slidesToShow: 1,
        arrows: true, 
        dots: false,
        infinite: true,
        fade: true,
        speed: 700,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.sym-slides-hotels').slick({
        slidesToShow: 4,
        accessibility: true,
        adaptiveHeight:false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    adaptiveHeight:true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    $('.sym-carousel').slick({
        variableWidth: true,
        accessibility: true,
        adaptiveHeight:false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                    adaptiveHeight:false,
                    fade:true
                }
            }
        ]
    });
    $('.prefecture-attractions__slider-slick').slick({
        variableWidth: true,
        accessibility: true,
        // adaptiveHeight:false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                    // adaptiveHeight:false,
                }
            }
        ]
    });
    
    $('.press-filter__slider').slick({
        arrows:false,
        dots:true,
        accessibility:false
    });


    let mapItems = document.querySelectorAll('.js-map-item[data-target], .pin-name[data-name]');
    let mapItemsImages = document.querySelectorAll('.map-location[data-name]');
    let mapItemsImagespins = document.querySelectorAll('.pin-name[data-name]');

    mapItemsImagespins.forEach(mapItemsImagepin => {
        let dataNameValue = mapItemsImagepin.dataset.name;
        mapItemsImagepin.addEventListener("click" , () => {
            let mapItemPin = document.querySelector(`.js-map-item[data-target=${dataNameValue}]`);
            // mapItemPin.click();
        })
    });

    mapItemsImages.forEach(mapItemsImage => {
        let dataNameValue = mapItemsImage.dataset.name;
        mapItemsImage.addEventListener("click" , () => {
            let dateLink = document.querySelector(`.js-map-item[data-target=${dataNameValue}]`);
            dateLink.click();
        })
    });

    if( window.innerWidth > 640 ){
        mapItems.forEach(item => {
            let dataTargetValue = item.dataset.target ? item.dataset.target : item.dataset.name;
            item.addEventListener('mouseover', () => {
                item.classList.add('hover')
                document.querySelector(`.map-location[data-name="${dataTargetValue}"]`).classList.add('hover');
            })
    
            item.addEventListener('mouseout', () => {
                item.classList.remove('hover')
                document.querySelector(`.map-location[data-name="${dataTargetValue}"]`).classList.remove('hover')
    
            })
        });
    }
    

})();

// Function to start setInterval call
function startInterval(){
    intervalID = setInterval(onloadReserve, 1500);
}

// Function to stop setInterval call
function stopInterval(){
    clearInterval(intervalID);
}
function onloadReserve(){
    let hash = window.location.hash.replace('#','');
    if(hash.length>0 && $('.offers-search__col').length>0){
        $('.offers-search__item[data-key='+hash+']').trigger('click');
        window.location.hash ='';
        stopInterval();
    }
}